/** Ordine commerciale piani SaaS palestra. */
export const GYM_SAAS_PLAN_ORDER = ['monthly', 'yearly'];

export function gymSaasPlanRank(planId) {
    const idx = GYM_SAAS_PLAN_ORDER.indexOf(planId);
    return idx >= 0 ? idx : GYM_SAAS_PLAN_ORDER.length;
}

/** Piano effettivo per confronto funzionalità (mensile e annuale condividono gli stessi moduli). */
export function resolveFeaturePlanId(planId) {
    if (planId === 'monthly' || planId === 'yearly' || planId === 'start' || planId === 'premium' || planId === 'elite') {
        return 'monthly';
    }
    return 'monthly';
}

export function planBillingInterval(plan) {
    if (plan?.billing_interval === 'year' || plan?.stripe_interval === 'year' || plan?.id === 'yearly') {
        return 'year';
    }
    return 'month';
}

export function resolveCurrentSaasPlanId(billing) {
    if (!billing) {
        return null;
    }
    if (billing.commercial_plan) {
        return billing.commercial_plan;
    }
    if (billing.billing_status === 'trialing' && billing.trial_feature_level) {
        return billing.trial_feature_level;
    }
    return billing.plan || null;
}

export function currentPlanFeatureKeySet(plans, currentPlanId) {
    if (!currentPlanId || !Array.isArray(plans)) {
        return new Set();
    }
    const plan = plans.find((p) => p.id === currentPlanId);
    if (!plan) {
        return new Set();
    }
    const keys = (plan.display_features || []).map((f) => f.key);
    if (keys.length) {
        return new Set(keys);
    }
    if (plan.feature_keys && typeof plan.feature_keys === 'object') {
        return new Set(
            Object.entries(plan.feature_keys)
                .filter(([, allowed]) => allowed)
                .map(([key]) => key),
        );
    }
    return new Set();
}

/** Badge «in più» rispetto al piano attuale (solo tra piani diversi con più funzioni). */
export function isFeatureNewInPlan(planId, featureKey, currentPlanId, currentFeatureKeys) {
    if (!currentPlanId || planId === currentPlanId) {
        return false;
    }
    const resolvedCurrent = resolveFeaturePlanId(currentPlanId);
    const resolvedPlan = resolveFeaturePlanId(planId);
    if (resolvedPlan === resolvedCurrent) {
        return false;
    }
    if (gymSaasPlanRank(planId) <= gymSaasPlanRank(currentPlanId)) {
        return false;
    }
    if (featureKey.startsWith('_core_')) {
        return false;
    }
    return !currentFeatureKeys.has(featureKey);
}
